import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

/**
 * The user table's columns, in render order.
 *
 * Labels match the table headers exactly — the menu is a list of what is on screen, so a different
 * wording there reads as a different column.
 *
 * Locked ones are the three a row cannot be read or acted on without: the selection checkbox the
 * export depends on, the name/email pair that says which account this is, and the actions menu.
 * `STT` is left unlocked — it is only a row counter.
 */
export const USER_COLUMNS = [
  { id: "select", label: "Selection", locked: true },
  { id: "index", label: "STT" },
  { id: "name", label: "Name / Email", locked: true },
  { id: "phone", label: "Phone Number" },
  { id: "role", label: "Role" },
  { id: "status", label: "Status" },
  { id: "security", label: "Security" },
  { id: "tenants", label: "Tenants" },
  { id: "lastLogin", label: "Last Login" },
  { id: "createdAt", label: "Created" },
  { id: "actions", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type UserColumnId = (typeof USER_COLUMNS)[number]["id"];

export const useUserColumnsStore = createColumnVisibilityStore<UserColumnId>({
  name: "admin.users.columns",
  columns: USER_COLUMNS,
});
